import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

const CardInfoComponent = ({
  color,
  bgColor,
  title,
  amount,
}: {
  color: string;
  bgColor: string;
  title: string;
  amount: number;
}) => {
  return (
    <Card
      sx={{ width: 300, height: 148, backgroundColor: bgColor, marginLeft: 2 }}
    >
      <CardContent sx={{ margin: "1px 2px 0px 18px" }}>
        <Typography gutterBottom sx={{ color: color, fontSize: 18 }}>
          {title}
        </Typography>

        <Typography variant="body2" sx={{ color: color, fontSize: 48 }}>
          {amount}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default CardInfoComponent;
